import StatusVisualization from './StatusVisualization';
import './StatusVisualization.scss';

export { schema, uiSchema } from '../schemas/StatusVisualizationSchema';
export default StatusVisualization;
